import { Injectable, Signal } from '@angular/core';
import { IPurposeData, IPurposeModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { IPurposeState, PurposeActions, PurposeSelectors } from '../store';

@Injectable({
  providedIn: 'root'
})
export class PurposeStore extends StateAccessService<IPurposeState> {
  readonly state$: Observable<IPurposeState>;

  readonly data$$: Signal<IPurposeData>;
  readonly model$$: Signal<IPurposeModel>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(PurposeSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(PurposeSelectors.data);
  }

  dispatchPurposeReset() {
    this.stateFacade.dispatch(PurposeActions.reset());
  }
  dispatchPurposeLoad() {
    this.stateFacade.dispatch(PurposeActions.load());
  }
  dispatchPurposeSubmit() {
    this.stateFacade.dispatch(PurposeActions.submit());
  }
  dispatchPurposeLoadSuccess({ model, data }: { model: IPurposeModel; data: IPurposeData }) {
    this.stateFacade.dispatch(PurposeActions.loadSuccess({ model, data }));
  }
  dispatchPurposeSubmitSuccess({ model, data }: { model: IPurposeModel; data: IPurposeData }) {
    this.stateFacade.dispatch(PurposeActions.submitSuccess({ model, data }));
  }
}
